import { Injectable, untracked} from "@angular/core";
import type {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
} from "@angular/router";
import { SessionDataService } from "./services/shared/SessionDataService.service";

/** Reuses same-route snapshots except while session restoration or an explicit URL reload is in progress. */
@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  private handlers: { [key: string]: DetachedRouteHandle } = {};

  constructor(private readonly SessionDataService: SessionDataService) {}

  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.handlers[route.url.join("/") || route.parent.url.join("/")] = handle;
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return this.handlers[route.url.join("/") || route.parent.url.join("/")];
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    // return future.routeConfig === curr.routeConfig;
    // URL reload flag
    let urlReloading = untracked(() => this.SessionDataService.urlReloadFlag());
    // Ensure no reload or session data loading is in progress
    if (
      !urlReloading &&
      !untracked(() => this.SessionDataService.sessionLoadingFlag())
    ) {
      // Same route: skip the reload
      if (future.url === curr.url) {
        return true;
      } else {
        return false;
      }
    } else {
      // A reload was pending: clear its flag
      if (urlReloading) {
        this.SessionDataService.clearUrlReloadFlag();
      }
      return false;
    }
  }
}
